<procure-badge
  [link]="link || null"
  [label]="label"
  [class]="class"
  [class.entity-badge--clickable]="clickable"
  [backgroundColor]="backgroundColor"
  [openInNewTab]="openInNewTab"
  [inverted]="inverted"
></procure-badge>
